import logo from './logo.svg';
import './App.css';
import Header from './Header';
import Column from './Column';
import Footer from './Footer';
import Post from './Post';
import Posts from './Posts';
import { Outlet, useParams } from "react-router-dom";
import Pagination from './Pagination';
import Pagination2 from './Pagination2';

function App() {
  let params = useParams();
  //alert(params.postId);
  if(!params.postId && !params.offset) {
    //alert(1);
    return (
      <div>
        <Header />
        <Column />
        <Pagination />
        <Footer />
      </div>
    );
  }else if(params.offset){
    //alert(params.offset);
    return (
      <div>
        <Header />
        <Posts offset={params.offset} />
        <Pagination2 />
        <Footer />
      </div>
    );
  }else {
    //alert(3);
    return (
      <div>
        <Header />
        <Post postId={params.postId} />
        <Footer />
      </div>
    );
  }
}

export default App;
